import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel", "badge"]
  static values = { panelUrl: String, open: { type: Boolean, default: false } }

  connect() {
    this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this)
    this.closeOnNavigate = () => this.close()
    document.addEventListener("turbo:before-visit", this.closeOnNavigate)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideClick)
    document.removeEventListener("turbo:before-visit", this.closeOnNavigate)
  }

  async toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.openValue) {
      this.close()
      return
    }

    await this.open()
  }

  async open() {
    const response = await window.fetch(this.panelUrlValue, {
      headers: { Accept: "text/html", "X-Requested-With": "XMLHttpRequest" },
    })

    if (!response.ok) return

    this.panelTarget.innerHTML = await response.text()
    this.panelTarget.hidden = false
    this.buttonTarget.setAttribute("aria-expanded", "true")
    this.openValue = true
    this.clearBadges()

    document.addEventListener("click", this.closeOnOutsideClick)
  }

  close() {
    if (!this.openValue) return

    this.panelTarget.hidden = true
    this.panelTarget.innerHTML = ""
    this.buttonTarget.setAttribute("aria-expanded", "false")
    this.openValue = false
    document.removeEventListener("click", this.closeOnOutsideClick)
  }

  closeOnOutsideClick(event) {
    if (this.element.contains(event.target)) return

    this.close()
  }

  clearBadges() {
    this.badgeTargets.forEach((badge) => badge.remove())
    this.buttonTarget.classList.remove(
      "site-header__bell--active",
      "dashboard-page__bell--active",
    )
    this.syncSidenavBadge()
  }

  syncSidenavBadge() {
    document
      .querySelectorAll("[data-notification-bell-sidenav-badge]")
      .forEach((badge) => {
        badge.remove()
      })
  }
}
